import { useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export const prefersReducedMotion = () =>
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

/**
 * Animates every element with [data-reveal] inside the scope.
 * Elements sharing the same data-reveal-group stagger together.
 */
export function useReveal(scopeRef) {
  useEffect(() => {
    if (prefersReducedMotion()) return;
    const scope = scopeRef.current;
    if (!scope) return;

    const ctx = gsap.context(() => {
      const els = scope.querySelectorAll("[data-reveal]");
      els.forEach((el) => {
        gsap.fromTo(
          el,
          { y: 48, opacity: 0 },
          {
            y: 0,
            opacity: 1,
            duration: 0.9,
            ease: "power3.out",
            delay: parseFloat(el.dataset.revealDelay || 0),
            scrollTrigger: { trigger: el, start: "top 88%", once: true },
          }
        );
      });
    }, scope);

    return () => ctx.revert();
  }, [scopeRef]);
}

export { gsap, ScrollTrigger };
